import Icon from '../components/Icon.vue'

Icon.register({
  'code-branch': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 144c0 35.2-22.8 65.1-54.4 75.9-0.5 28.1-7.6 50.5-21.6 67.9-28.2 35-76 39.5-118.2 43.4-25.7 2.4-49.9 4.6-66.1 12.8-7.1 3.6-11.8 8.2-14.9 13.4 30 11.5 51.2 40.6 51.2 74.6 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.4v-199.3c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3v144c23.9-11.5 53.1-14.3 81.3-16.9 35.9-3.3 69.8-6.5 85.2-25.7 6.8-8.4 10.4-20.8 11-36.9-33.2-9.7-57.5-40.4-57.5-76.8 0-44.2 35.8-80 80-80s80 35.8 80 80zM80 64c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zM80 448c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM304 128c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16z'
      }
    ]
  }
})
